import axios from 'axios';
import store from '@/store/store'

const url = '/api/v1/external/task-templates'

class TaskTemplateService {
	
	static addTemplate(template, token) {
		return axios.post(
			url,
			{
				data: template,
			},
			{
				headers: { Authorization: `Bearer ${token}` },
			}
		)
	}

	static deleteTemplate(templateId, token) {
        
		return axios.delete(url + '/' + templateId, {
		    headers: {Authorization: `Bearer ${token}`}
		})
		
	}

	static getTemplates(ownerId, filter, token) {
        
		return axios.get(url + "/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
		    headers: {Authorization: `Bearer ${token}`}
		})
	 }

	static getPublicTemplates(filter) {
        
		//return axios.get(url + '-public' + "/" + encodeURIComponent(JSON.stringify(filter)))
		return axios.get(url + "/" + encodeURIComponent(JSON.stringify(filter)))
	 }

	static setSystemValues(template) {

		let newTemplate = template
  
		// Default some values if the template is new and others if it is being modified.
		if(typeof template._id == 'undefined' || template._id === null) {

			newTemplate.added = Date.now()
			newTemplate.owner = store.getters.getUser._id
			newTemplate.timesUsed = 0

		} else {

			newTemplate.modified = Date.now()

		}

		
  
		return newTemplate
  
  
	 }

	static updateTemplate(template, token) {
        
		return axios.put(url, {
		    data: template
		}, {
		    headers: {Authorization: `Bearer ${token}`}
		})
		
	}

	static updateTimesUsed(templateId, token) {
        
		return axios.put(url + '/add-used', {
		    data: templateId
		}, {
		    headers: {Authorization: `Bearer ${token}`}
		})
		
	}
}

export default TaskTemplateService
